import React, { useState } from "react";
import "./layout.css";
import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import { setSidebarProfileWidth } from "../../redux/slice/actionSlice";
import store from "../../redux/store";
import { Drawer } from "antd";
import styles from "../../screens/profile/profile.module.css";
import SidebarProfile from "../sidebar/SidebarProfile";
import { CgMenuLeftAlt } from "react-icons/cg";
import Button from "../btn/Button";
import EquipmentBulkUpload from "../../screens/Home/EquipmentBulkUpload";

const LayoutProfile = React.memo(() => {
  const { smallSidebarProfileWidth } = useSelector((state) => state.actions);
  const { godown_address_list } = useSelector((state) => state.profile);
  const [isExcel, setIsExcel] = useState(false);
  
  return (
    <div>
      <div className={styles.profile_head}>
        <div
          className={styles.title_main}
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <div className={styles.title_main}>Account Info</div>
            {godown_address_list?.length > 0 && (
              <Button onClick={() => setIsExcel(true)} title="BULK UPLOAD" />
            )}
          </div>
          {/* <div>Account Info</div> */}
          {/* {user_type === "admin" && ( */}
          <div className={styles.profile_icon}>
            <CgMenuLeftAlt
              size={30}
              className="cursor"
              color="#9e72ff"
              onClick={() => {
                store.dispatch(
                  setSidebarProfileWidth(!smallSidebarProfileWidth),
                );
              }}
            />
          </div>
          {/* )} */}
        </div>
        <div className={styles.subtitle_main}>
          You have full control to manage your own account setting
        </div>
      </div>
      <div className=" layout-profile" style={{ backgroundColor: "#f5f6fa" }}>
        <div
          className="layout-sidebar"
          style={{
            width: smallSidebarProfileWidth ? "6rem" : "20rem",
            transition: "width ease 1s",
            paddingTop: "1rem",
            backgroundColor: "#fff",
            borderRadius: "12px",
          }}
        >
          <SidebarProfile onClose={() => console.log("")} />
        </div>
        <div className="sidebar-new">
          <Drawer
            width={"16rem"}
            placement={"right"}
            destroyOnClose={true}
            rootClassName={"sidebar-new"}
            Header={false}
            onClose={() =>
              store.dispatch(setSidebarProfileWidth(!smallSidebarProfileWidth))
            }
            open={smallSidebarProfileWidth}
          >
            <SidebarProfile
              onClose={() =>
                store.dispatch(
                  setSidebarProfileWidth(!smallSidebarProfileWidth),
                )
              }
            />
          </Drawer>
        </div>

        <div
          className={`layout-body `}
          style={{ backgroundColor: "#f5f6fa", borderRadius: "12px" }}
        >
          <div className="layout-outlet2">
            <Outlet />
          </div>
        </div>
      </div>
      {isExcel && <EquipmentBulkUpload isFTL={isExcel} setIsFTL={setIsExcel} />}
    </div>
  );
});

export default LayoutProfile;
